module.exports = __webpack_public_path__ + "img/west-2-high-school-photo.9b1436c0.jpg";